import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FormControlLabel from '@mui/material/FormControlLabel';
import Link from "@mui/material/Link";
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { visuallyHidden } from "@mui/utils";


import React, {useEffect, useState} from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import HeaderBar from "../components/HeaderBar";
import {jwtDecode} from "jwt-decode";
import PropTypes from "prop-types";
import { alpha } from '@mui/material/styles';
import TextField from "@mui/material/TextField";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: 'id',
    numeric: false,
    disablePadding: false,
    label: 'RGA Number',
  },
  {
    id: 'customer_claim_number',
    numeric: false,
    disablePadding: false,
    label: 'Company Claim Number',
  },
  {
    id: 'customer_company_name',
    numeric: false,
    disablePadding: false,
    label: 'Company',
  },
  {
    id: 'pn',
    numeric: false,
    disablePadding: false,
    label: 'PN',
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    label: 'Status',
  },
  {
    id: 'import_status',
    numeric: false,
    disablePadding: false,
    label: 'Import Status',
  },
  {
    id: 'email_conf_status',
    numeric: false,
    disablePadding: false,
    label: 'Email Confirmation Status',
  },
  {
    id: 'imported_date',
    numeric: false,
    disablePadding: false,
    label: 'Imported Date (MM-DD-YYYY)',
  },
];

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {/*<TableCell padding="checkbox">*/}
        {/*  <Checkbox*/}
        {/*    color="primary"*/}
        {/*    indeterminate={numSelected > 0 && numSelected < rowCount}*/}
        {/*    checked={rowCount > 0 && numSelected === rowCount}*/}
        {/*    onChange={onSelectAllClick}*/}
        {/*    inputProps={{*/}
        {/*      'aria-label': 'select all claims',*/}
        {/*    }}*/}
        {/*  />*/}
        {/*</TableCell>*/}
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected, handleOpenFilter, completedChecked, cancelledChecked, handleChangeCheckboxCompleted, handleChangeCheckboxCancelled } = props;

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          RGA Claims
        </Typography>
      )}

      {/*{numSelected > 0 ? (*/}
      {/*    <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>*/}
      {/*        <Button variant="contained" onClick={handleImport}>*/}
      {/*            Import*/}
      {/*        </Button>*/}
      {/*    </Box>*/}
      {/*) : (*/}
      {/*  <Tooltip title="Filter list">*/}
      {/*    <IconButton>*/}
      {/*      <FilterListIcon />*/}
      {/*    </IconButton>*/}
      {/*  </Tooltip>*/}
      {/*)}*/}
        <Box>
            <FormControlLabel control={<Checkbox checked={completedChecked} onChange={handleChangeCheckboxCompleted} />} label="Hide Completed Claims"/>
        </Box>
        <Box>
            <FormControlLabel control={<Checkbox checked={cancelledChecked} onChange={handleChangeCheckboxCancelled} />} label="Hide Cancelled Claims"/>
        </Box>
      <Tooltip title="Filter list">
        <IconButton onClick={handleOpenFilter}>
          <FilterListIcon />
        </IconButton>
      </Tooltip>
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
  handleOpenFilter: PropTypes.func.isRequired,
  completedChecked: PropTypes.func.isRequired,
  cancelledChecked: PropTypes.func.isRequired,
  handleChangeCheckboxCompleted: PropTypes.func.isRequired,
  handleChangeCheckboxCancelled: PropTypes.func.isRequired,
};

const initialId = "";
const initialCompanyClaimId = "";
const initialCompanyName = "";
const initialPn = "";
const initialStatus = "Pending";
const initialImportStatus = "Select";
const initialEmailConfStatus = "Select";

function ViewAllRGAList() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [defaultRgaList, setDefaultRgaList] = useState([]);
  const [defaultMergedRgaList, setDefaultMergedRgaList] = useState([]);
  const [rgaList, setRgaList] = useState([]);
  const [completedRgaList, setCompletedRgaList] = useState([]);
  const [cancelledRgaList, setCancelledRgaList] = useState([]);

  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [filterId, setFilterId] = useState(initialId);
  const [filterCompanyClaimId, setFilterCompanyClaimId] = useState(initialCompanyClaimId);
  const [filterCompanyName, setFilterCompanyName] = useState(initialCompanyName);
  const [filterPn, setFilterPn] = useState(initialPn);
  const [filterStatus, setFilterStatus] = useState(initialStatus);
  const [filterImportStatus, setFilterImportStatus] = useState(initialImportStatus);
  const [filterEmailConfStatus, setFilterEmailConfStatus] = useState(initialEmailConfStatus);

  const [hideFilterCompleted, setHideFilterCompleted] = useState(true);
  const [hideFilterCancelled, setHideFilterCancelled] = useState(true);

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('id');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [appliedFilters, setAppliedFilters] = useState([]);

  const addAppliedFilter = (filter) =>
    setAppliedFilters((current) => {
      if (current.includes(filter)) return current;
      return [...current, filter];
    });

  const removeAppliedFilter = (filter) =>
    setAppliedFilters((current) => current.filter((e) => e !== filter));

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rgaList.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rgaList.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      stableSort(rgaList, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      ),
    [order, orderBy, page, rowsPerPage, rgaList],
  );

  const handleSelectRGA = (event, selectedRGA) => {
      // console.log(selectedRGA);
      navigate('/view_rga', { state: { rga_number: selectedRGA } });
  }

  const handleFilterOpen = (event) => {
      setOpenFilterDialog(true);
  }

  const handleFilterClose = (event) => {
      setOpenFilterDialog(false);
  }

  const handleResetFilters = () => {
    setAppliedFilters([]);
    setRgaList(defaultRgaList);
    setFilterId(initialId);
    setFilterCompanyClaimId(initialCompanyClaimId)
    setFilterCompanyName(initialCompanyName);
    setFilterPn(initialPn);
    setFilterStatus(initialStatus);
    setFilterImportStatus(initialImportStatus);
    setFilterEmailConfStatus(initialEmailConfStatus);
  };

  const handleChangeCheckBoxCompleted = () => {
      setHideFilterCompleted(!hideFilterCompleted);
      if (!hideFilterCompleted) {
          const newRgaList = rgaList.filter((r) => r.status !== "Complete");
          setRgaList(newRgaList);
          setDefaultMergedRgaList(newRgaList);
      }
      else {
          const mergedList = [...rgaList, ...completedRgaList];
          setRgaList(mergedList);
          setDefaultMergedRgaList(mergedList);
      }
  }

  const handleChangeCheckBoxCancelled = () => {
      setHideFilterCancelled(!hideFilterCancelled);
      if (!hideFilterCancelled) {
          const newRgaList = rgaList.filter((r) => r.status !== "Cancelled");
          setRgaList(newRgaList);
          setDefaultMergedRgaList(newRgaList);
      }
      else {
          const mergedList = [...rgaList, ...cancelledRgaList];
          setRgaList(mergedList);
          setDefaultMergedRgaList(mergedList);
      }
  }

  useEffect(() => {
      axios.get('/api/allrgas')
          .then(function (response) {
          // console.log(response);
          if (response.status === 200) {
              const rga_list = response.data.rgalist;
              // console.log(rga_list);
              const rga_list_pending_only = rga_list.filter((r) => {
                  try {
                    const filterPendingStatusRegEx = new RegExp("Pending", "gi");
                    return r.status.match(filterPendingStatusRegEx);
                  } catch {
                    return r.status.indexOf("Pending") !== -1;
                  }
              });
              const rga_list_completed_only = rga_list.filter((r) => {
                  try {
                    const filterCompletedStatusRegEx = new RegExp("Complete", "gi");
                    return r.status.match(filterCompletedStatusRegEx);
                  } catch {
                    return r.status.indexOf("Complete") !== -1;
                  }
              });
              const rga_list_cancelled_only = rga_list.filter((r) => {
                  try {
                    const filterCancelledStatusRegEx = new RegExp("Cancelled", "gi");
                    return r.status.match(filterCancelledStatusRegEx);
                  } catch {
                    return r.status.indexOf("Cancelled") !== -1;
                  }
              });
              setCompletedRgaList(rga_list_completed_only);
              setCancelledRgaList(rga_list_cancelled_only);
              setRgaList(rga_list_pending_only);
              setDefaultRgaList(rga_list_pending_only);
              setDefaultMergedRgaList(rga_list_pending_only);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
  }, []);

  // useEffect(() => {
  //     // For controlling the checkboxes for hiding the completed and cancelled claims
  //     if (hideFilterCompleted && hideFilterCancelled) {
  //         setRgaList(defaultRgaList);
  //         setDefaultMergedRgaList(defaultRgaList);
  //     }
  //     else if (!hideFilterCompleted && hideFilterCancelled) {
  //         const mergedList = [...defaultRgaList, ...completedRgaList];
  //         setRgaList(mergedList);
  //         setDefaultMergedRgaList(mergedList);
  //     }
  //     else if (hideFilterCompleted && !hideFilterCancelled) {
  //         const mergedList = [...defaultRgaList, ...cancelledRgaList];
  //         setRgaList(mergedList);
  //         setDefaultMergedRgaList(mergedList);
  //     }
  //     else {
  //         const mergedList = [...defaultRgaList, ...cancelledRgaList];
  //         const doubleMergedList = [...mergedList, completedRgaList];
  //         setRgaList(doubleMergedList);
  //         setDefaultMergedRgaList(doubleMergedList);
  //     }
  // }, [hideFilterCompleted, hideFilterCancelled]);

  useEffect(() => {
      // For updating the filters
      const updatedRGAList = defaultMergedRgaList
          .filter((r) => {
              if (initialId !== filterId) {
                  addAppliedFilter("id");
                  const r_id = r.id.toString();
                  try {
                    const filterIdRegEx = new RegExp(filterId, "gi");
                    return r_id.match(filterIdRegEx);
                  } catch {
                    return r_id.indexOf(filterId) !== -1;
                  }
              }
              removeAppliedFilter("id");
              return true;
          })
          .filter((r) => {
              if (initialCompanyClaimId !== filterCompanyClaimId) {
                  addAppliedFilter("companyClaimId");
                  try {
                    const filterCompanyClaimIdRegEx = new RegExp(filterCompanyClaimId, "gi");
                    return r.customer_claim_number.match(filterCompanyClaimIdRegEx);
                  } catch {
                    return r.customer_claim_number.indexOf(filterCompanyClaimId) !== -1;
                  }
              }
              removeAppliedFilter("companyClaimId");
              return true;
          })
          .filter((r) => {
              if (initialCompanyName !== filterCompanyName) {
                  addAppliedFilter("companyName");
                  try {
                    const filterCompanyNameRegEx = new RegExp(filterCompanyName, "gi");
                    return r.customer_company_name.match(filterCompanyNameRegEx);
                  } catch {
                    return r.customer_company_name.indexOf(filterCompanyName) !== -1;
                  }
              }
              removeAppliedFilter("companyName");
              return true;
          })
          .filter((r) => {
              if (initialPn !== filterPn) {
                  addAppliedFilter("pn");
                  try {
                    const filterPnRegEx = new RegExp(filterPn, "gi");
                    return r.pn.match(filterPnRegEx);
                  } catch {
                    return r.pn.indexOf(filterPn) !== -1;
                  }
              }
              removeAppliedFilter("pn");
              return true;
          })
          .filter((r) => {
              if (initialImportStatus !== filterImportStatus) {
                  addAppliedFilter("import_status");
                  try {
                    const filterImportStatusRegEx = new RegExp(filterImportStatus, "gi");
                    return r.import_status.match(filterImportStatusRegEx);
                  } catch {
                    return r.import_status.indexOf(filterImportStatus) !== -1;
                  }
              }
              removeAppliedFilter("import_status");
              return true;
          })
          .filter((r) => {
                  if (initialEmailConfStatus !== filterEmailConfStatus) {
                      addAppliedFilter("email_conf_status");
                      try {
                        const filterEmailConfRegEx = new RegExp(filterEmailConfStatus, "gi");
                        return r.email_conf_status.match(filterEmailConfRegEx);
                      } catch {
                        return r.email_conf_status.indexOf(filterEmailConfStatus) !== -1;
                      }
                  }
                  removeAppliedFilter("email_conf_status");
                  return true;
              });
      setRgaList(updatedRGAList);
  }, [filterId, filterCompanyClaimId, filterCompanyName, filterPn, filterStatus, filterImportStatus, filterEmailConfStatus, hideFilterCompleted, hideFilterCancelled]);

  return (
      <Box>
          <HeaderBar />
          <Stack direction='column' spacing={2}>
              <Box sx={{ mt: 1, display: 'flex', justifyContent: 'center' }}>
                  <Typography variant="h4" gutterBottom> All RGAs </Typography>
              </Box>
              <Box sx={{ width: '100%' }}>
                  <Paper sx={{ width: '100' }}>
                      <EnhancedTableToolbar numSelected={selected.length}
                                            handleOpenFilter={handleFilterOpen}
                                            completedChecked={hideFilterCompleted}
                                            cancelledChecked={hideFilterCancelled}
                                            handleChangeCheckboxCompleted={handleChangeCheckBoxCompleted}
                                            handleChangeCheckboxCancelled={handleChangeCheckBoxCancelled}/>
                      <TableContainer>
                          <Table sx={{ minWidth: 650 }} aria-label="All RGA List Table">
                              {/*<TableHead>*/}
                              {/*    <TableRow>*/}
                              {/*        <TableCell>Claim Number</TableCell>*/}
                              {/*        <TableCell>Customer</TableCell>*/}
                              {/*        <TableCell>PN</TableCell>*/}
                              {/*        <TableCell>Status</TableCell>*/}
                              {/*    </TableRow>*/}
                              {/*</TableHead>*/}
                              <EnhancedTableHead
                                  numSelected={selected.length}
                                  order={order}
                                  orderBy={orderBy}
                                  onSelectAllClick={handleSelectAllClick}
                                  onRequestSort={handleRequestSort}
                                  rowCount={rgaList.length}
                                />
                              <TableBody>
                                  {visibleRows.map((row, index) => {
                                    const isItemSelected = isSelected(row.id);
                                    const labelId = `enhanced-table-checkbox-${index}`;

                                    return (
                                      <TableRow
                                        // hover
                                        // onClick={(event) => handleClick(event, row.id)}
                                        // role="checkbox"
                                        // aria-checked={isItemSelected}
                                        // tabIndex={-1}
                                        key={row.id}
                                        // selected={isItemSelected}
                                        // sx={{ cursor: 'pointer' }}
                                      >
                                        {/*<TableCell padding="checkbox">*/}
                                        {/*  <Checkbox*/}
                                        {/*    color="primary"*/}
                                        {/*    checked={isItemSelected}*/}
                                        {/*    onClick={(event) => handleClick(event, row.id)}*/}
                                        {/*    inputProps={{*/}
                                        {/*      'aria-labelledby': labelId,*/}
                                        {/*    }}*/}
                                        {/*  />*/}
                                        {/*</TableCell>*/}
                                        <TableCell component="th" scope="row"><Link onClick={(event) =>
                                            handleSelectRGA(event, row.id)}>{row.id}</Link></TableCell>
                                        <TableCell>{row.customer_claim_number}</TableCell>
                                        <TableCell>{row.customer_company_name}</TableCell>
                                        <TableCell>{row.pn}</TableCell>
                                        <TableCell>{row.status}</TableCell>
                                        <TableCell>{row.import_status}</TableCell>
                                        <TableCell>{row.email_conf_status}</TableCell>
                                        <TableCell>{row.imported_date}</TableCell>
                                      </TableRow>
                                    );
                                  })}
                                  {emptyRows > 0 && (
                                    <TableRow
                                      style={{
                                        height: (dense ? 33 : 53) * emptyRows,
                                      }}
                                    >
                                      <TableCell colSpan={5} />
                                    </TableRow>
                                  )}
                              </TableBody>
                          </Table>
                      </TableContainer>
                      <TablePagination
                          rowsPerPageOptions={[10, 25, 50]}
                          component="div"
                          count={rgaList.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                  </Paper>
              </Box>
          </Stack>
          <Dialog open={openFilterDialog} onClose={handleFilterClose}>
              <DialogTitle>Filters</DialogTitle>
              <DialogContent>
                  <DialogContentText>Please select filters here.</DialogContentText>
                  <TextField
                      value={filterId}
                      onChange={(e) => setFilterId(e.target.value)}
                      label="RGA Number"
                      variant="filled"
                      fullwidth/>
                  <TextField
                      value={filterCompanyClaimId}
                      onChange={(e) => setFilterCompanyClaimId(e.target.value)}
                      label="Company Claim Number"
                      variant="filled"
                      fullwidth/>
                  <TextField
                      value={filterCompanyName}
                      onChange={(e) => setFilterCompanyName(e.target.value)}
                      label="Company"
                      variant="filled"
                      fullwidth/>
                  <TextField
                      value={filterPn}
                      onChange={(e) => setFilterPn(e.target.value)}
                      label="PN"
                      variant="filled"
                      fullwidth/>
                  {/*<Select id="select-status" value={filterStatus} label="Status" onChange={(e) => setFilterStatus(e.target.value)}>*/}
                  {/*    <MenuItem value={"Pending"}>Pending</MenuItem>*/}
                  {/*    <MenuItem value={"Completed"}>Completed</MenuItem>*/}
                  {/*</Select>*/}
                  <Select id="select-import-status" value={filterImportStatus} label="Import Status" onChange={(e) => setFilterImportStatus(e.target.value)}>
                      <MenuItem value={"Pending"}>Pending</MenuItem>
                      <MenuItem value={"Completed"}>Completed</MenuItem>
                  </Select>
                  <Select id="select-email-conf-status" value={filterEmailConfStatus} label="Status" onChange={(e) => setFilterEmailConfStatus(e.target.value)}>
                      <MenuItem value={"Pending"}>Pending</MenuItem>
                      <MenuItem value={"Return"}>Return</MenuItem>
                      <MenuItem value={"Scrap"}>Scrap</MenuItem>
                      <MenuItem value={"Missing Parts"}>Missing Parts</MenuItem>
                  </Select>
              </DialogContent>
              <DialogActions>
                  <Button onClick={handleResetFilters}>Reset</Button>
                  <Button onClick={handleFilterClose}>Close</Button>
              </DialogActions>
          </Dialog>
      </Box>
  );
}

export default ViewAllRGAList;